export default __webpack_public_path__ + "static/background-image-04ee206abb9d5983169dff04ddd1ec41.jpg";